import { makeRemoteAccountEnrollmentDetail } from '@/main/factories/usecases/account/remote-account-enrollment-factory'
import { RemoteAccountEnrollmentDetail } from '@/data/usecases/account/remote-account-enrollment'
import { ApiInstanceResponse } from '@/infra/http/http-service-client/http-service-client-types'
import { queryClient } from '@/infra/http'

/**
 * Loads a single enrollment detail by ID
 * @param enrollmentId - The enrollment ID to load
 */
export async function loadUserEnrollmentDetail(
  enrollmentId: string
): Promise<RemoteAccountEnrollmentDetail.Model> {
  const remoteAccountEnrollment = makeRemoteAccountEnrollmentDetail(queryClient)
  const result = (await remoteAccountEnrollment.loader(
    enrollmentId
  )) as unknown as ApiInstanceResponse<RemoteAccountEnrollmentDetail.Model>
  // The API returns { success, message, data }, but we need just the data
  return result.data || (result as unknown as RemoteAccountEnrollmentDetail.Model)
}
